export default __webpack_public_path__ + "static/laagom_block_base-38ef80947d51c6fa4535a1c81d9f8437.png";